import { WidgetRepository } from '../../../widgets/repository/WidgetRepository.ts';
import { type Widget } from '../../../widgets/Widget.ts';
import { type ITranslationKey } from '../../ITranslationKey.ts';
import { type ITranslationSchema } from '../TranslationSchema.ts';
import {
  BaseTranslationSchema,
  type ITranslationUpdateContext,
  TranslationSchemaType,
} from './BaseTranslationSchema.ts';
import { TranslationObjectSchema } from './TranslationObjectSchema.ts';

export class TranslationWidgetSchema extends BaseTranslationSchema {
  type = TranslationSchemaType.Widget;
  objectSchema?: TranslationObjectSchema;

  constructor(private shape?: Record<string, ITranslationSchema>) {
    super();
    if (shape) {
      this.objectSchema = new TranslationObjectSchema(shape);
    }
  }

  get objectShape() {
    return this.objectSchema?.shape ?? {};
  }

  /**
   * Se lo schema viene fornito, provvede a utilizzare quell'oggetto.
   * Alternativamente risolve lo schema in base alla repository.
   */
  private resolveObjectSchema(widget: Widget): ITranslationSchema | undefined {
    if (this.objectSchema) return this.objectSchema;

    return WidgetRepository.find(widget.type)?.translationSchema?.objectSchema;
  }

  extract(value: any, path = '', prefix = ''): ITranslationKey[] {
    const widget = value as Widget;
    if (!widget) return [];

    const schema = this.resolveObjectSchema(widget);
    if (!schema) {
      // biome-ignore format: <tbd>
      console.warn(`Nessuno schema di traduzione trovato per il widget di tipo [${widget.type}]`);
      return [];
    }

    return schema.extract(value, path, `${widget.id}`);
  }

  translateValue(
    value: any,
    path: string,
    prefix: string,
    ctx: ITranslationUpdateContext,
  ) {
    const widget = value as Widget;
    if (!widget) return;

    const schema = this.resolveObjectSchema(widget);
    if (!schema) {
      // biome-ignore format: <tbd>
      console.warn(`Nessuno schema di traduzione trovato per il widget di tipo [${widget.type}]`);
      return;
    }

    schema.translateValue(value, path, `${widget.id}`, ctx);
  }
}
